"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateBasketInputValue = exports.getEnrichOutcomesWithPlayerNames = exports.getIsEventEnded = exports.getIsEventPending = exports.getDisplayTypeError = exports.getFormattedErrors = exports.mapNewBetListItems = exports.getErrorMessage = exports.getNewBasketOutcome = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const constants_1 = require("../../containers/BasketProvider/constants");
const types_1 = require("../../containers/BasketProvider/types");
const types_2 = require("../../containers/ConfigProvider/types");
const getNewBasketOutcome = ({ eventProbability, event, }) => {
    const { outcomeTypeId, parameters } = eventProbability;
    const { live, id: eventId } = event;
    return {
        outcomeTypeId,
        parameters,
        eventId,
        live,
    };
};
exports.getNewBasketOutcome = getNewBasketOutcome;
const getErrorMessage = (errors) => errors.map(({ code }) => code);
exports.getErrorMessage = getErrorMessage;
const transformOutcomes = (outcomes) => outcomes.map((outcome) => ({
    outcomeId: outcome.id,
    coefficient: outcome.probability.odd,
}));
const mapNewBetListItems = ({ outcomes, systemSize, betAmount, betType, bonusWallet, }) => [
    {
        outcomes: transformOutcomes(outcomes),
        systemSize,
        bet: betAmount,
        betType: betweb_openapi_axios_1.BetType[betType],
        bonusWallet,
    },
];
exports.mapNewBetListItems = mapNewBetListItems;
const getFormattedErrors = (errors, config) => errors.map((error) => ({
    message: constants_1.ALL_BASKET_ERROR_MESSAGES[error] || constants_1.ALL_BASKET_ERROR_MESSAGES.ERROR,
    displayType: (0, exports.getDisplayTypeError)(error, config),
    code: error,
}));
exports.getFormattedErrors = getFormattedErrors;
const getDisplayTypeError = (error, config) => {
    if (config.CLIENT_TYPE === types_2.EClientTypes.WEB_MOBILE ||
        config.CLIENT_TYPE === types_2.EClientTypes.NATIVE_IOS ||
        config.CLIENT_TYPE === types_2.EClientTypes.NATIVE_ANDROID) {
        return constants_1.MOBILE_BOTTOM_ERRORS.includes(error)
            ? types_1.EDisplayType.BOTTOM
            : types_1.EDisplayType.TOP;
    }
    else if (config.CLIENT_TYPE === types_2.EClientTypes.WEB_DESKTOP) {
        return constants_1.WEB_BOTTOM_ERRORS.includes(error)
            ? types_1.EDisplayType.BOTTOM
            : types_1.EDisplayType.TOP;
    }
    return types_1.EDisplayType.BOTTOM;
};
exports.getDisplayTypeError = getDisplayTypeError;
const getIsEventPending = (outcomeStatus, eventStatus, probabilityStatus) => constants_1.pendingOutcomeStatus.includes(outcomeStatus) ||
    constants_1.pendingEventStatus.includes(eventStatus) ||
    constants_1.pendingProbabilityStatus.includes(probabilityStatus);
exports.getIsEventPending = getIsEventPending;
const getIsEventEnded = (eventStatus, probabilityStatus) => constants_1.endedEventStatus.includes(eventStatus) ||
    constants_1.endedProbabilityStatus.includes(probabilityStatus);
exports.getIsEventEnded = getIsEventEnded;
const getEnrichOutcomesWithPlayerNames = (outcomes, players) => {
    return outcomes.map((outcome) => {
        return {
            ...outcome,
            probability: {
                ...outcome.probability,
                parameters: outcome.probability.parameters.map((param) => {
                    if (param.type === betweb_openapi_axios_1.ParameterType.PlayerId) {
                        const player = players && players[param.value];
                        if (player) {
                            return { ...param, playerName: player.name };
                        }
                    }
                    return param;
                }),
            },
        };
    });
};
exports.getEnrichOutcomesWithPlayerNames = getEnrichOutcomesWithPlayerNames;
const listOfReplacementValuesForBasketInput = [
    '00',
    '01',
    '02',
    '03',
    '04',
    '05',
    '06',
    '07',
    '08',
    '09',
];
const dot = '.';
const comma = ',';
const regExOnlyNumbers = /^[0-9]+$/;
const regExForWholeValue = /^[0-9]*\d?(\.)(\d{1,2})?$/;
const validateBasketInputValue = (e) => {
    const inputValue = e.target.value.replaceAll(' ', '').replace(comma, dot);
    // if user writes the first character as "dot", we explicitly return 0.
    if (inputValue.length === 1 && inputValue.includes(dot)) {
        return `0${dot}`;
        // if the user forgot to write a "dot" for certain cases, we add a "dot" between characters
    }
    else if (listOfReplacementValuesForBasketInput.includes(inputValue)) {
        return inputValue.split('').join(dot);
        // case when user adds only numbers
    }
    else if (regExOnlyNumbers.test(inputValue)) {
        return inputValue;
    }
    else {
        // if regEx pass the test, we return new value else we return previous value
        return regExForWholeValue.test(inputValue)
            ? inputValue
            : inputValue.slice(0, -1);
    }
};
exports.validateBasketInputValue = validateBasketInputValue;
//# sourceMappingURL=index.js.map